import React from 'react'
import { useDispatch } from 'react-redux'
import { setDrawer } from 'slices/drawer'
import { STATICS } from 'statics'
import { DRAWER_KEY } from 'app-constants'
import { Button } from 'components'
import './style.scss'

export function AccessStoreError() {
  const dispatch = useDispatch()

  function handleClick() {
    dispatch(setDrawer(DRAWER_KEY.NONE))
  }

  return (
    <div className='container-access-error'>
      <div className='container-info'>
        <div className='container-image'>
          <STATICS.INFO_OUTLINE />
        </div>
        <span className='title'>Não foi possível acessar a loja de serviços</span>
        <span className='description'>Por favor, tente novamente em alguns minutos.</span>
      </div>
      <Button color='primary' onClick={handleClick} className='button'>
        <STATICS.BACK /> Voltar para home
      </Button>
    </div>
  )
}
